module.exports = __webpack_public_path__ + "img/prioritas_bosspack_dfod.9384c5d6.png";